import React from "react";

import { SupBreadcrumb, SupBreadcrumbs } from "@repo/core-ui";

export interface DetailsBreadCrumb {
  href?: string;
  name: string;
}

interface UiDetailsBreadcrumbsProps {
  breadCrumbs: DetailsBreadCrumb[];
  className?: string;
}

export default function UiDetailsBreadcrumbs({ className, breadCrumbs }: UiDetailsBreadcrumbsProps) {
  return (
    <SupBreadcrumbs className={className} maxItems={breadCrumbs.length}>
      {breadCrumbs.map((breadCrumb, index) => (
        <SupBreadcrumb
          key={`breadcrumb-${index}`}
          link={
            breadCrumb.href
              ? {
                  href: breadCrumb.href,
                  className: "text-neutral-900 decoration-from-font lg:hover:text-primary-600 h-6 flex items-center justify-center",
                }
              : undefined
          }
          className={breadCrumb.href ? "" : "flex h-6 cursor-default items-center justify-center"}
        >
          {breadCrumb.name}
        </SupBreadcrumb>
      ))}
    </SupBreadcrumbs>
  );
}
